module.exports = __webpack_public_path__ + "static/media/canaan_anatolia_icon_small.c8fb8def.png";